import { render, staticRenderFns } from "./HandIdCard.vue?vue&type=template&id=b854b1e8&scoped=true&"
import script from "./HandIdCard.vue?vue&type=script&lang=js&"
export * from "./HandIdCard.vue?vue&type=script&lang=js&"
import style0 from "./HandIdCard.vue?vue&type=style&index=0&id=b854b1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b854b1e8",
  null
  
)

export default component.exports